import React from 'react';
import { motion } from 'framer-motion';

const Web3Hero = () => {
  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="section-container">
        {/* Create your identity Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Create your identity and explore Web3.
          </h2>
          <p className="text-xl lg:text-2xl text-gray-600 mb-16 max-w-4xl">
            Your identity is a unique wallet address that can be connected to one or more non-custodial wallets. Here's how to get started:
          </p>
        </motion.div>
        
        {/* Steps in 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative"
          >
            {/* Vertical line for mobile, hidden on desktop */}
            <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-amber-200 md:hidden"></div>
            
            <div className="flex items-start space-x-4 md:block md:space-x-0">
              <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 relative z-10 md:mb-4">
                <span className="text-amber-800 font-bold text-sm">1</span>
              </div>
              <div>
                <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-4">Get started</h3>
                <p className="text-lg text-gray-600 leading-relaxed">Create a new wallet or connect it to an already existing non-custodial address.</p>
              </div>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="relative"
          >
            {/* Vertical line for mobile, hidden on desktop */}
            <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-amber-200 md:hidden"></div>
            
            <div className="flex items-start space-x-4 md:block md:space-x-0">
              <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 relative z-10 md:mb-4">
                <span className="text-amber-800 font-bold text-sm">2</span>
              </div>
              <div>
                <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-4">Activate identity</h3>
                <p className="text-lg text-gray-600 leading-relaxed">Activate your identity across all available networks.</p>
              </div>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="relative"
          >
            {/* Vertical line for mobile, hidden on desktop */}
            <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-amber-200 md:hidden"></div>
            
            <div className="flex items-start space-x-4 md:block md:space-x-0">
              <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 relative z-10 md:mb-4">
                <span className="text-amber-800 font-bold text-sm">3</span>
              </div>
              <div>
                <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-4">Add funds</h3>
                <p className="text-lg text-gray-600 leading-relaxed">Fund your identity via a crypto transfer to start using the full suite of services.</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Web3Hero; 